






import axios from 'axios'
import consola from 'consola'
import isEmpty from 'lodash/fp/isEmpty'
import { defineComponent, useAsync, useContext } from '@nuxtjs/composition-api'

export default defineComponent({
  setup() {
    const ctx = useContext()

    const data = useAsync<any>(() => ctx.payload)

    return {
      data,
    }
  },
  async asyncData(ctx) {
    try {
      const protocolId = ctx.route.params.id
      const protocolUrl = `${ctx.$config.cst.mediaUrl}/json2/protocol/${protocolId}`

      const response = await axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        url: protocolUrl,
      })

      if (!response.data && isEmpty(response.data['step-protocol']?.markup)) {
        return ctx.error({ statusCode: 404 })
      }

      ctx.payload = { markup: response.data['step-protocol'].markup }
    } catch (e: any) {
      consola.error('Error getting protocol page: %s', e.message)
      if (e.response.status === 404) {
        return ctx.error({ statusCode: 404 })
      }
      return ctx.error({ message: e.message, statusCode: 500 })
    }
  },
})
